import PublicNav from "@/components/PublicNav";
import PublicFooter from "@/components/PublicFooter";
import Seo from "@/components/Seo";

export default function Terms() {
  return (
    <div className="min-h-screen bg-[#F7F5F0]" data-testid="terms-page">
      <Seo
        title="Terms of Service"
        description="The terms of using CareHomeConnect's senior care matching service."
        path="/terms"
      />
      <PublicNav />
      <section className="max-w-3xl mx-auto px-6 md:px-12 pt-12 md:pt-20 pb-8">
        <div className="text-sm text-[#9CAF88] font-semibold mb-3 uppercase tracking-wider">Legal</div>
        <h1 className="font-display text-4xl sm:text-5xl font-semibold text-[#1A2E24] tracking-tight">
          Terms of Service
        </h1>
        <p className="mt-5 text-sm text-[#5C6B62]">Last updated: February 2026</p>
      </section>

      <section className="max-w-3xl mx-auto px-6 md:px-12 pb-20 text-[#1A2E24] text-base leading-relaxed space-y-6">
        <p>
          Welcome to CareHomeConnect. By using our website, quiz, articles, or partner portal
          (the &quot;Service&quot;), you agree to these terms. If you do not agree, please don&apos;t
          use the Service.
        </p>

        <h2 className="font-display text-2xl font-semibold text-[#1A2E24] mt-10">What we do</h2>
        <p>
          CareHomeConnect is a free educational and referral service. We help families understand
          senior care options and, when helpful, connect them with licensed senior living
          communities and placement professionals (&quot;Partners&quot;).
        </p>

        <h2 className="font-display text-2xl font-semibold text-[#1A2E24] mt-10">Not medical or legal advice</h2>
        <p>
          Our articles, quiz results, and recommendations are for informational purposes only. They
          are not a substitute for professional medical, legal, or financial advice. Always consult
          a qualified professional for decisions about care, health, or finances.
        </p>

        <h2 className="font-display text-2xl font-semibold text-[#1A2E24] mt-10">Your submissions</h2>
        <ul className="list-disc pl-6 space-y-2">
          <li>You agree the information you provide is accurate and that you are authorized to share it.</li>
          <li>By submitting the quiz, you consent to be contacted by CareHomeConnect and the matched Partner by email, phone, or SMS regarding senior care options.</li>
          <li>Message and data rates may apply to SMS. Reply STOP at any time to opt out.</li>
        </ul>

        <h2 className="font-display text-2xl font-semibold text-[#1A2E24] mt-10">Partner relationships</h2>
        <p>
          CareHomeConnect may receive a referral fee from Partners when a family moves into a
          community. This never affects the price you pay — our service is always free to families.
          We don&apos;t rank Partners by who pays the most; we match based on your needs,
          location, and budget.
        </p>

        <h2 className="font-display text-2xl font-semibold text-[#1A2E24] mt-10">Accounts</h2>
        <p>
          Partner and admin accounts are restricted to authorized users. You&apos;re responsible
          for safeguarding your login credentials and for anything that happens under your account.
          Notify us immediately at <a className="text-[#2C4C3B] underline" href="mailto:support@carehomeconnect.com">support@carehomeconnect.com</a> if
          you suspect unauthorized use.
        </p>

        <h2 className="font-display text-2xl font-semibold text-[#1A2E24] mt-10">Acceptable use</h2>
        <ul className="list-disc pl-6 space-y-2">
          <li>Don&apos;t use the Service to harass, defraud, or submit another person&apos;s information without consent.</li>
          <li>Don&apos;t attempt to reverse engineer, scrape, or disrupt the Service.</li>
          <li>Don&apos;t use the Service to send spam or unlawful communications.</li>
        </ul>

        <h2 className="font-display text-2xl font-semibold text-[#1A2E24] mt-10">Intellectual property</h2>
        <p>
          All content (articles, design, logos) is owned by CareHomeConnect or its licensors. You
          may read and share articles for personal use with attribution, but you may not
          republish, resell, or modify our content without written permission.
        </p>

        <h2 className="font-display text-2xl font-semibold text-[#1A2E24] mt-10">Disclaimers</h2>
        <p>
          The Service is provided &quot;as is&quot; without warranties of any kind. We do not
          guarantee availability of any particular community, pricing, or care outcome. Your
          decision to move forward with a Partner is yours.
        </p>

        <h2 className="font-display text-2xl font-semibold text-[#1A2E24] mt-10">Limitation of liability</h2>
        <p>
          To the fullest extent permitted by law, CareHomeConnect is not liable for indirect,
          incidental, or consequential damages arising from your use of the Service. Our total
          liability will not exceed USD $100.
        </p>

        <h2 className="font-display text-2xl font-semibold text-[#1A2E24] mt-10">Changes</h2>
        <p>
          We may update these terms from time to time. Continued use after changes means you accept
          the new terms.
        </p>

        <h2 className="font-display text-2xl font-semibold text-[#1A2E24] mt-10">Contact</h2>
        <p>
          Questions? Email <a className="text-[#2C4C3B] underline" href="mailto:support@carehomeconnect.com">support@carehomeconnect.com</a>.
        </p>
      </section>
      <PublicFooter />
    </div>
  );
}
